import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { ReferralService } from '../../services/referral-service';
import { Referral, Note } from '../../models/referral';
import { BackButtonComponent } from '../../../../shared/components/back-button/back-button.component';
import { EditReferralNoteDialogComponent } from '../edit-referral-note-dialog/edit-referral-note-dialog.component';
import { Logger } from '../../../../infrastructure/logging/logger';

@Component({
  selector: 'app-referral-detail',
  templateUrl: './referral-detail.component.html',
  styleUrls: ['./referral-detail.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    CommonModule,
    RouterLink,
    FormsModule,
    MatOptionModule,
    MatSelectModule,
    BackButtonComponent
  ]
})
export class ReferralDetailComponent implements OnInit {

  router: Router;
  route: ActivatedRoute;
  referral!: Referral;

  // edit detail toggle
  canEdit = false;

  // note template form
  subject?: string | null;
  comment?: string | null;

  constructor(
    private _api: ReferralService, 
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private logService: Logger,
    router: Router, 
    route: ActivatedRoute
  ) {
    this.router = router;
    this.route = route;
  }

  ngOnInit(): void {
    // the referral item is sourced from the ReferralResolver service
    this.route.data.subscribe(({ referral }) => {
      if (referral) {
        this.referral = referral;
      }
    });
  }

  updateReferral() {
    if (this.referral) {
      this.addAdditionalNote();
      // save it

      this._api.updateReferral(this.referral).subscribe({
        next: (result) => {
          if (result) {
            this.snackbar.open('Referral updated successfully', 'OK', { duration: 3000 });
            this.router.navigate(['/referrals']);
          }
        },
        error: (error) => {
          this.logService.handleError(error, 'An error occurred while updating Referral', 'Error while updating Referral');
        }
      });
    }
  }

  private addAdditionalNote(){
    if (this.comment !== null && this.comment !== "" && this.comment !== undefined){
      this.referral?.addNote(new Note("", this.subject ? this.subject : "", this.comment, new Date(), new Date()));
    }
  }

  canSubmit(): boolean {
    if (this.referral) {
      return this.referral.isValid();
    } else {
      return false;
    }
  }

  openEditReferralNoteDialog(note: any, index: number) {
    const dialogRef = this.dialog.open(EditReferralNoteDialogComponent, {
      width: '50%',
      maxHeight: '600px',
      data: note
    });
    dialogRef.afterClosed().subscribe((note) => {
      if (note != undefined) {
        this.referral.notes[index].subject = note.subject;
        this.referral.notes[index].comment = note.comment;
        this.referral.notes[index].lastModifiedDate = new Date();
      }
    });
  }

  onDeleteReferralNoteClick(index: number) {
    this.referral?.notes.splice(index, 1);
  }
}
